import { computed } from 'vue';
import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import {
  hasDiensthaftpflicht,
  hasTarifWithMinors,
  isTarifgruppeBeamterReactive,
} from '@/features/Sparten/phv/formConfigs/sharedRenderConditions';

const isNotABeamter: ConditionalRequestDefinition = {
  if: computed(() => !isTarifgruppeBeamterReactive.value),
  drop: ['diensthaftpflicht', 'diensteigenschaft', 'zugangsweg'],
};

const hasNoDiensthaftpflicht: ConditionalRequestDefinition = {
  if: computed(() => !hasDiensthaftpflicht.value),
  drop: [
    'taetigkeit',
    'regressHaftpflicht',
    'schadenEigentumSchule',
    'abhandengekommeneGegenstaende',
    'dienstschluessel',
    'kassenfehlbetraege',
    'erweiterteVermoegensschadenDeckung',
    'dienstHundeHaftpflicht',
    'dienstPferdeHaftpflicht',
    'geraeteHaftpflicht',
    'dienstfahrzeugRegress',
  ],
};

const hasNoTarifWithMinors: ConditionalRequestDefinition = {
  if: computed(() => !hasTarifWithMinors.value),
  drop: ['kinderUnter7'],
};

export const phvInputDehydrationDefinitions: ConditionalRequestDefinition[] = [
  isNotABeamter,
  hasNoDiensthaftpflicht,
  hasNoTarifWithMinors,
];
